import { PaymentMethodLogo } from '@wix/billing-client-common';
import * as React from 'react';
import s from './AcceptedPaymentMethods.scss';
import { Box } from '@wix/design-system';
export const AcceptedPaymentMethodIcons = ({ paymentMethods }) => {
    return (React.createElement(Box, { direction: "horizontal" }, paymentMethods?.map((paymentMethod) => (React.createElement("span", { key: paymentMethod, "data-hook": paymentMethod, className: s.acceptedPaymentMethodIcon },
        React.createElement(PaymentMethodLogo, { cardBrand: paymentMethod, className: s.paymentMethodLogo }))))));
};
//# sourceMappingURL=AcceptedPaymentMethodIcons.js.map